import Expandable from './expandable';

const expandableConfig = {
  name: 'expandable',
  class: Expandable,
  querySelector: {
    heading: '.expandable__heading',
  },
};

export default expandableConfig;
